import React from 'react'

import Content from '../../components/Content';
import Title from '../../components/Title';
import Wrapper from '../../components/Wrapper';

import Slide from "./Slide";

const extractProps = (props) => {
  if(props.children[0] && props.children[0].props.mdxType === 'h1') {
    const cloneProps = { ...props };

    cloneProps.title = props.children[0].props.children;
    cloneProps.children = props.children.slice(1);

    return cloneProps;
  }

  return props;
};

export default (props) => {
  props = extractProps(props);

  return (
    <Wrapper>
      <Slide>
        <Title>{props.title || "Speakers"}</Title>
        <Content {...props} />
      </Slide>
    </Wrapper>
  )
}